import React from 'react';
import PropTypes from 'prop-types';
import DetailsCell from './details_cell';
import { componentText } from '../../utils/i18n_utils';

const YardageRow = ({ tee }) => {
  const nrHoles = tee.holeData.yardage.length;
  return (
    <tr className="lbv2__yardage-row">
      <DetailsCell className="lbv2__yardage text sticky">{componentText('details_table.yards', 'Yards')}</DetailsCell>
      {tee.holeData.yardage.map((yardage, index) => (
        <React.Fragment key={index}>
          <DetailsCell className="lbv2__yardage">{yardage}</DetailsCell>
          {index === 8 && nrHoles === 18 && <DetailsCell className="lbv2__yardage sum-front">{tee.yardageSumFront}</DetailsCell>}
          {index === 17 && nrHoles === 18 && <DetailsCell className="lbv2__yardage sum-back">{tee.yardageSumBack}</DetailsCell>}
          {index === (nrHoles - 1) && <DetailsCell className="lbv2__yardage total">{tee.yardage}</DetailsCell>}
        </React.Fragment>
      ))}
    </tr>
  );
};

YardageRow.propTypes = {
  tee: PropTypes.object.isRequired,
};

export default YardageRow;
